import React, { FC } from 'react'
import { List, Modal } from 'antd'
import {
  EditOutlined,
  DeleteFilled,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from '~/Store/hooks'
import { getOrganizationUsersByRole } from '~/Store/Organization/selectors'
import { SystemClaim } from '../../Routes'
import { roleModalName } from './constant'
import { RolesResponse } from '~/Services/AdminRolesService'
import { RolesActions } from '~/Store/Role'
import { useTranslation } from 'react-i18next'

const { confirm } = Modal
interface RolePanelHeaderProps {
  role: RolesResponse
}

export const RolePanelHeader: FC<RolePanelHeaderProps> = ({ role }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const orgUsers = useAppSelector(state =>
    getOrganizationUsersByRole(state, role.name),
  )

  const deleteRole = async (roleName: string) => {
   dispatch(RolesActions.deleteRoleRequest({ roleName, type: 'User' }))
  }

  const showDeleteConfirm = (roleName: string) => {
    confirm({
      title: `${t('confirmRemoveMessage')} ${roleName}?`,
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteRole(roleName)
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }

  const openEditRoleModal = (role: RolesResponse) => {
    dispatch(RolesActions.setSystemRoleSelected(role))
    dispatch(
      RolesActions.setModalState({ name: roleModalName, value: true }),
    )
  }

  return (
    <div style={{ display: 'inline-flex', width: '80%' }}>
      <List.Item.Meta
        title={
          <>
            <span style={{ fontWeight: 'bolder' }}>{role.name}</span>
            {![SystemClaim.System, SystemClaim.User].some(
              item => item === role.name,
            ) && (
              <>
                <EditOutlined
                  style={{ marginLeft: '20px', color: '#1890ff' }}
                  data-id={role.id}
                  onClick={event => {
                    openEditRoleModal(role)
                    event.stopPropagation()
                  }}
                />
                <DeleteFilled
                  style={{ marginLeft: '10px', color: 'red' }}
                  onClick={event => {
                    showDeleteConfirm(role.name)
                    event.stopPropagation()
                  }}
                />
              </>
            )}
          </>
        }
        // description={t('assignedToUsers', { count: orgUsers.length })}
      />
    </div>
  )
}
